import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import {User} from '../../Interfaces/User';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {ListData} from '../../Interfaces/ListData';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {SharedVarService} from '../shared-service.service';
import {AppComponent} from '../../app.component';
import {QueryService} from '../../Services/query.service';
import NumberFormatOptions = Intl.NumberFormatOptions;

import {DetentionClaimsView} from '../../Interfaces/DetentionClaimsView';
import {GlobalEventsManager} from '../../GlobalEventManager';
import * as XLSX from 'xlsx';
import {DetentionClaimsExcel} from '../../Interfaces/DetentionClaimsExcel';
import {MatTableDataSource} from '@angular/material/table';
import {MatSelect} from '@angular/material/select';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {MatOption} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';





@Component({
  selector: 'app-detention-claim-inquiry',
  templateUrl: './detention-claim-inquiry.component.html',
  styleUrls: ['./detention-claim-inquiry.component.css']
})
export class DetentionClaimInquiryComponent implements OnInit, OnDestroy {
  public savedList: string;
  public statusChosen: string;
  public statusChosen2: string [] = [];

  private listData: ListData[];
  private listDataObj: ListData;
  public savedList2: string;
  myNewListName: string = "";

  public savedLists2 : {id: string, code:string, description:string}[] = [];
  public savedLists : {code:string, description:string}[] = [];
  public listStatus : {code:string, description:string}[] = [];
  myUser: User;
  private clientRequest: ClientRequest;
  public didntEnterShit: boolean = false;
  public badChars: boolean = false;
  public insertNoConts: boolean = false;
  public noListName: boolean = false;
  public insertListExists: boolean = false;
  public showQuickView: boolean = false;
  public showInsert: boolean = false;
  public allFound: boolean = false;
  public foundOneSelected: boolean = false;
  private start: string;
  private end: string;
  private stringOut: string;
  private containerNum: string;
  public badSearch: boolean = false;
  public inquiryOnly: boolean = true;
  public showDetailScreen: boolean = false;
  public showInsertScreen: boolean = false;
  showAcc: boolean = false;

  public inSearch: boolean = false;
  public ipadAppear: boolean = true;
  public notANumber: boolean = false;
  public submitted: boolean = false;
  public oneIsInAlready: boolean = false;
  myForm: UntypedFormGroup;
  myForm2: UntypedFormGroup;
  private date3: UntypedFormControl;
  txtFromArea: string;
  txtArray2: string [] = [];
  sub: any;
  private subscription: Subscription; start_date_in: string; end_date_in: string;
  private detDetails: DetentionClaimsView [] = [];
  private detDetails2: DetentionClaimsView [] = [];
  private detDetail: DetentionClaimsView;
  private detentionExcelArray: DetentionClaimsExcel[] = [];
  private detentionExcel: DetentionClaimsExcel;
  quickViewData: MatTableDataSource<DetentionClaimsView>;
  insertData: MatTableDataSource<DetentionClaimsView>;
  search1: UntypedFormControl;
  search2: UntypedFormControl;
  public qvColumns: string[];
  public insColumns: string[];
  private currentIndx: number;
  private date1: Date;
  private number1: number;
  private claimCol: string = "Claim Amount";
  private claimDateCol: string = "Claim Date";
  public maherError: string = "";


  insertSubmitted: boolean= false;
  foundAGoodOne: boolean= false;
  insertError: boolean = false;
  phoneApp: boolean = false;
  allowIn: boolean = false;
  dontAllowIn: boolean = false;
  ipadApp: boolean = false;
  private options4: Intl.DateTimeFormatOptions = {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  };

  private options2: NumberFormatOptions = {maximumFractionDigits: 2};
  private options3: { currencyDisplay: string; minimumFractionDigits: number; style: string; currency: string } = {style: 'currency', currency: 'USD', currencyDisplay: 'symbol', minimumFractionDigits: 2};
  public today: Date = new Date();
  delay;
  private dateFilter: (date: Date) => boolean;

  allSelected = false;

  @ViewChild('mySel') skillSel: MatSelect;

  @ViewChild(MatSort) set content(sort: MatSort) {
    if (this.quickViewData != undefined) {
      this.quickViewData.sort = sort;
    }
    if (this.insertData != undefined) {
      this.insertData.sort = sort;
    }

  }

  @ViewChild(MatPaginator) set content2(pag: MatPaginator) {
    if (this.quickViewData != undefined) {
      this.quickViewData.paginator = pag;
    }
    if (this.insertData != undefined) {
      this.insertData.paginator = pag;
    }

  }

  setCheckedField(){
    if (this.showInsert){
      this.showInsert=false;
    }else{
      this.showInsert=true;
    }
    this.showInsertScreen = false;
    this.insertSubmitted = false;
    this.showDetailScreen = false;
    this.showQuickView = false;


  }
  getListData(){
    this.savedLists = [];
    this.savedLists.push({"code": "VISIT", "description": "Visit"});
    this.savedLists.push({"code": "CLAIMNUMBER", "description": "Claim Number"});
    if (!this.phoneApp){
      this.savedLists.push({"code": "CLAIMSTATUS", "description": "Claim Status"});
      this.savedLists.push({"code": "CLAIMSTATUSDATE", "description": "Claim Date & Status"});
    }
    this.savedList = this.savedLists[0].code;

    this.listStatus = [];
    this.listStatus.push({"code": "P", "description": "Pending"});
    this.listStatus.push({"code": "A", "description": "Authorized"});
    this.listStatus.push({"code": "C", "description": "Closed"});
    this.listStatus.push({"code": "R", "description": "Rejected"});
    this.statusChosen = this.listStatus[0].code;


  }


  toggleAllSelection() {
    this.allSelected = !this.allSelected;  // to control select-unselect

    if (this.allSelected) {
      this.skillSel.options.forEach( (item : MatOption) => item.select());
    } else {
      this.skillSel.options.forEach( (item : MatOption) => {item.deselect()});
    }
  }

  toggleOtherOptions(){
    this.skillSel.options.first.deselect();
  }



  public wipeOutSearch(){
    this.txtFromArea = null;
    this.showQuickView = false;
    this.showDetailScreen = false;
  }

  wipeOutScreen() {
    this.showQuickView = false;
    this.showDetailScreen = false;
    this.submitted = false;
    this.insertSubmitted = false;
    this.showInsertScreen  = false;
    this.showInsert = false;

    if (window.innerWidth > 800){
      this.fillUpSavedLists();
    }
  }


  submitClaims(){


    this.insertError = false;
    this.insertSubmitted = false;
    if (this.myForm2.valid) {
      this.clientRequest = null;
      this.clientRequest = {} as ClientRequest;
      this.clientRequest.user = this.myUser;

      for (var i = 0; i<this.detDetails.length;i++) {
        if (this.detDetails[i].claim_amount != null){
          this.detDetails2.push(this.detDetails[i]);
        }
      }
      this.clientRequest.requestData = [];
      this.clientRequest.requestData = this.detDetails2;

      const lhsUserObs2$ = this.queryService.claimEntryProcess(this.clientRequest);
      this.subscription = lhsUserObs2$.subscribe(
        (dets) => {
          this.detDetails = dets;},
        error=> {
          if (error.status=="401"){
            this.globalEventsManager.showLogin.emit(true);

            this.router.navigate(["login"]);
          }else{
            this.myApp.openDialog(error.message)
          }
        },
        ()=> {
          this.insertSubmitted = true;
          for (var items of this.detDetails){
            if (items.maherError!=null) {
            } else {
              items.claim_date = this.getNiceDateTimeForDate(new Date());
              items.claim_by = this.myUser.username;
              items.claim_amount = this.getNiceCurrency(items.claim_amount);
            }
          }
          this.showInsertScreen = true;
          this.showDetailScreen = false;
          this.insertSubmitted  = true;
          this.foundAGoodOne = false;

          this.search2.reset();
          this.insertData = new MatTableDataSource<DetentionClaimsView>(this.detDetails);


        });
    }else{
      this.insertError = true;
      this.insertSubmitted = true;
    }


  }



  dontShowSearch(){
    if (this.ipadApp){
      this.inSearch = true;
      this.allowIn = false;
    }
  }

  returnToSearch2(){
    if (this.ipadApp){
      this.showInsertScreen = false;
      this.inSearch = false;
      this.allowIn = true;
      this.showQuickView = false;
    }
  }



  constructor(fb: UntypedFormBuilder, private router: Router, private service: SharedVarService,private  globalEventsManager: GlobalEventsManager, private myApp: AppComponent, private  queryService: QueryService) {
    this.qvColumns = ["detention_claim_id", "visit", "claim_amount", "claim_date", "status_description", "ap_transfered_date", "authorized_amount","rejection_description","claim_remarks"];
    this.insColumns = ["detention_claim_id", "visit", "claim_amount","claim_remarks", "claim_date","claim_by","maherError"];


    this.sub =  this.service.getConfirmed().subscribe((value) => {
      if (value){
        this.updateContainerList('D');
        this.service.setConfirmed(false);
      }
    });



    this.myForm = fb.group({
      datefield: ['', [Validators.required]]});

    this.myForm2 = fb.group({
      remarks: ['', [Validators.maxLength(30)]],
      amount: ['', [Validators.pattern('^[1-9]\\d*(((,\\d{3}){1})?(\\.\\d{0,2})?)$')]]});


    this.myUser = this.myApp.user;

/*
    this.myUser = {} as User;
    this.myUser.active ="Y"
    this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
    this.myUser.address_2 = null
     this.myUser.company_code ="S0452"
   //this.myUser.company_code ="A0436"
    this.myUser.company_name= "MAHER TERMINALS, LLC"
    this.myUser.city= "HOUSTON"
    this.myUser.email_address= null
    this.myUser.fax_number= null
    this.myUser.first_name= "Csp Craig"
    this.myUser.last_name= "Miller"
    this.myUser. maherError= null
    this.myUser.old_password= null
    this.myUser.password= ""
    this.myUser.phone_number= null
    this.myUser.company_scac= "MHER"
    this.myUser.state= "TX"
    this.myUser.userMenuReportItemsView= null
    this.myUser.menuRoleArray = [];
    this.myUser.menuRoleArray[0] = "CSP_CONSIGNEE_ROLE";
    this.myUser.user_gkey= "8237887"
   //  this.myUser.role= "AGENT"
   //  this.myUser.role= "LINEOP"
   this.myUser.role= "HAULIER"
    this.myUser.username="CSPTRUCKERLUCY"
    this.myUser.zip="07201"
    this.myUser.canSeeAllData = "1";
    this.myUser.trucker_vender_id = "Y";


 */


  }



  exportExcel() {
    this.detentionExcelArray = [];
    for (var xx=0; xx<this.quickViewData.filteredData.length; xx++){
      this.detentionExcel = {} as DetentionClaimsExcel ;
      this.detentionExcel.Claim = this.quickViewData.filteredData[xx].detention_claim_id;
      this.detentionExcel.Visit = this.quickViewData.filteredData[xx].visit;
      this.detentionExcel.Amount = this.quickViewData.filteredData[xx].claim_amount;
      this.detentionExcel.ClaimDate = this.quickViewData.filteredData[xx].claim_date;
      this.detentionExcel.Status = this.quickViewData.filteredData[xx].status_description;
      this.detentionExcel.Transferred = this.quickViewData.filteredData[xx].ap_transfered_date;
      this.detentionExcel.Authorized = this.quickViewData.filteredData[xx].authorized_amount;
      this.detentionExcel.Rejection = this.quickViewData.filteredData[xx].rejection_description;
      this.detentionExcel.Notes = this.quickViewData.filteredData[xx].claim_remarks;


      this.detentionExcelArray.push(this.detentionExcel);

    }
    const workSheet = XLSX.utils.json_to_sheet(this.detentionExcelArray );
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    var wscols = [
      {wch:10},
      {wch:10},
      {wch:10},
      {wch:15},
      {wch:10},
      {wch:12},
      {wch:12},
      {wch:50},
      {wch:50},
    ];
    workSheet['!cols'] = wscols;
    XLSX.utils.book_append_sheet(workBook, workSheet, 'DetentionInquiry');
    XLSX.writeFile(workBook, 'detentionInquiry.xlsx');
  }


  fillUpSavedLists(){
    this.savedLists2 = [];
    if (this.savedList=="VISIT"){
      this.listDataObj.type = "V";
    }else if (this.savedList=="CLAIMNUMBER"){
      this.listDataObj.type = "L";
    }

    for (var item of this.listData){
      if (item.type == this.listDataObj.type){
        this.savedLists2.push({"id": item.id, "code": item.name, "description": item.name});
      }
    }
    if (this.savedLists2.length>0){
      this.savedList2 = this.savedLists2[0].id;
    }
  }


  private getVisitsForInsert(){

    if (this.oneIsInAlready){
      return;
    }
    this.oneIsInAlready = true;

    this.showInsertScreen = false;
    this.insertSubmitted = false;
    this.foundAGoodOne = false;
    if (this.txtFromArea == undefined) {
      this.didntEnterShit = true;
      this.oneIsInAlready = false;

      return;
    }

    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');

    this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
    if (this.txtArray2.length == 0) {
      this.didntEnterShit = true;
      this.oneIsInAlready = false;

      return;
    }
    this.didntEnterShit = false;
    var _i = this.txtArray2.length;
    while (_i--) {
      this.txtArray2[_i] = this.txtArray2[_i].valueOf().trim();
      if (!this.service.checkForSpecialChars(this.txtArray2[_i].valueOf())) {
        this.containerNum = this.txtArray2[_i].valueOf();
        this.badChars = true;
        this.oneIsInAlready = false;
        return;
      }
      if (this.txtArray2[_i].valueOf() == "") {
        this.txtArray2.splice(_i, 1);
      }else{
        if (isNaN(Number(this.txtArray2[_i].valueOf()))) {
          this.notANumber = true;
          this.oneIsInAlready = false;
          return;
        }
      }
    }
    if (this.txtArray2.length == 0) {
      this.didntEnterShit = true;
      this.oneIsInAlready = false;
      return;
    }
    this.txtArray2 = this.service.onlySendOneHundread(this.txtArray2);

    this.detDetail = {} as DetentionClaimsView;
    this.detDetails = [];

    for (var items of this.txtArray2){
      this.detDetail = {} as DetentionClaimsView;
      this.detDetail.visit = items.valueOf();
      if (this.detDetails.findIndex(xx => xx.visit == this.detDetail.visit) ==-1){
        this.detDetails.push(this.detDetail);
      }

    }

    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    this.clientRequest.requestData = this.detDetails;

    const lhsUserObs2$ = this.queryService.claimEntryByVisit(this.clientRequest);
    this.subscription = lhsUserObs2$.subscribe(
      (dets) => {
        this.detDetails = dets;},
      error=> {
        if (error.status=="401"){
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        }else{
          this.myApp.openDialog(error.message)
        }
      },
      ()=> {
        this.oneIsInAlready = false;
        for (var items of this.detDetails){
          if (items.maherError!=null) {

          } else {
            this.foundAGoodOne = true;
            items.claim_date = this.getNiceDateTimeForDate(new Date());
            items.claim_by = this.myUser.username;
          }
        }
        this.showInsertScreen = true;
        this.showDetailScreen = false;
        this.search2.reset();
        this.insertData = new MatTableDataSource<DetentionClaimsView>(this.detDetails);

        if (window.innerWidth > 750 && window.innerWidth <1150){
          this.allowIn = false;
        }
      });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  ngOnInit() {

    if (window.innerWidth > 750 && window.innerWidth <1150){
      this.ipadApp = true;
    }
    if (window.innerWidth <= 800){
      this.phoneApp = true;
    }
    if (window.innerWidth<1151){
      this.claimCol = "Amount";
      this.claimDateCol = "Date";
    }else if (window.innerWidth<1500){
      this.claimCol = "Claim Amt.";

    }

    if (this.myUser.trucker_vender_id=="N"){ //dont allow them to see this screen
      this.dontAllowIn = true;
    }else{
      this.allowIn = true;
    }

    this.search1 = new UntypedFormControl();
    this.search2 = new UntypedFormControl();
    this.getListData();
    this.getListData2();
    this.checkMenuRoles();





  }

  checkMenuRoles(){
    for (var item of this.myUser.menuRoleArray){
      if ((item.toUpperCase().includes("ENTRY")) || (item.toUpperCase()=="CSP_CONSIGNEE_ROLE") || (item.toUpperCase()=="CSP_ALL_DATA") || (item.toUpperCase()=="CSP_ALL_MENUS") ){
        this.inquiryOnly = false;
      }
    }
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    this.quickViewData.filter = filterValue;
  }


  emitDates() {
    this.start = "";
    this.end = "";
    this.start = this.getNiceDate(this.start_date_in);
    this.end = this.getNiceDate(this.end_date_in);
  }

  getSearchItems() {

    if (this.oneIsInAlready){
      return;
    }

    this.allFound = false;
    this.foundOneSelected = false;
    this.showQuickView = false;
    this.showDetailScreen = false;
    this.submitted = true;
    this.oneIsInAlready = true;
    this.badSearch = false;
    this.didntEnterShit = false;
    this.badChars = false;
    this.notANumber = false;
    if (this.savedList == "VISIT" || this.savedList == "CLAIMNUMBER" ) {
      if (this.txtFromArea == undefined) {
        this.didntEnterShit = true;
        this.oneIsInAlready = false;
        return;
      }

      this.txtFromArea = this.txtFromArea.replace(" ",'\n');
      this.txtFromArea = this.txtFromArea.replace(" ",'\n');
      this.txtFromArea = this.txtFromArea.replace(" ",'\n');
      this.txtFromArea = this.txtFromArea.replace(" ",'\n');
      this.txtFromArea = this.txtFromArea.replace(" ",'\n');

      this.txtArray2 = [];
      this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
      if (this.txtArray2.length == 0) {
        this.didntEnterShit = true;
        this.oneIsInAlready = false;
        return;
      }
      this.didntEnterShit = false;
      var _i = this.txtArray2.length;
      while (_i--) {
        this.txtArray2[_i] = this.txtArray2[_i].valueOf().trim();
        if (!this.service.checkForSpecialChars(this.txtArray2[_i].valueOf())) {
          this.containerNum = this.txtArray2[_i].valueOf();
          this.badChars = true;
          this.oneIsInAlready = false;
          return;
        }

        if (this.txtArray2[_i].valueOf() == "") {
          this.txtArray2.splice(_i, 1);
        }else{
          if (isNaN(Number(this.txtArray2[_i].valueOf()))) {
            this.notANumber = true;
            this.oneIsInAlready = false;
            return;
          }
        }
      }
      if (this.txtArray2.length == 0) {
        this.didntEnterShit = true;
        this.oneIsInAlready = false;
        return;
      }
      this.txtArray2 = this.service.onlySendOneHundread(this.txtArray2);


    }

    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.detDetail = {} as DetentionClaimsView;
    this.detDetails = [];
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    var lhsUserObs$;
    if (this.savedList == "VISIT") {
      for (var items of this.txtArray2){
        this.detDetail = {} as DetentionClaimsView;
        this.detDetail.visit = items.valueOf();
        if (this.detDetails.findIndex(xx => xx.visit == this.detDetail.visit) ==-1){
          this.detDetails.push(this.detDetail);
        }
      }
      this.clientRequest.requestData = this.detDetails;
      lhsUserObs$ = this.queryService.claimInquiryByVisit(this.clientRequest);
    } else if (this.savedList == "CLAIMNUMBER") {
      for (var items of this.txtArray2){
        this.detDetail = {} as DetentionClaimsView;
        this.detDetail.detention_claim_id = items.valueOf();
        if (this.detDetails.findIndex(xx => xx.detention_claim_id == this.detDetail.detention_claim_id) ==-1){
          this.detDetails.push(this.detDetail);
        }
      }
      this.clientRequest.requestData = this.detDetails;
      lhsUserObs$ = this.queryService.claimInquiryByClaim(this.clientRequest);
    } else if (this.savedList == "CLAIMSTATUS" || this.savedList == "CLAIMSTATUSDATE") {

      this.skillSel.options.forEach( (item : MatOption) => {
        if (item.selected){
          this.foundOneSelected = true;
          if (item.value=='P'){
            this.detDetail.isPending="1";
          }else if (item.value=='A'){
            this.detDetail.isAuthorized="1";
          }else if (item.value=='R'){
            this.detDetail.isRejected="1";
          }else if (item.value=='C'){
            this.detDetail.isClosed="1";
          }else if (item.value=='ALL'){
            this.allFound = true;
          }
        }
      });

      if (!this.foundOneSelected){
        this.didntEnterShit = true;
        this.oneIsInAlready = false;
        return;
      }
      if (this.savedList == "CLAIMSTATUSDATE") {
        if (this.start==null){
          this.didntEnterShit = true;
          this.oneIsInAlready = false;
          return;
        }
        this.detDetail.claim_from_date = this.start;
        this.detDetail.claim_to_date = this.end;
      }
      this.clientRequest.requestData[0] = this.detDetail;
      if (this.savedList == "CLAIMSTATUS"){
          lhsUserObs$ = this.queryService.byFilter(this.clientRequest);
      }else{
          lhsUserObs$ = this.queryService.byFilterAndDates(this.clientRequest);
      }
    }
    this.subscription = lhsUserObs$.subscribe(
      (claim) => {
        this.detDetails = claim;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        this.oneIsInAlready = false;
        this.maherError = null;

        if (this.detDetails.length>0) {

            if (this.detDetails.length == 1) {
              if (this.detDetails[0].maherError != null) {
                  this.maherError = this.detDetails[0].maherError;
              } else {
                this.detDetail = this.detDetails[0];
                this.currentIndx = 0;
                this.formatDetailScreen();
                this.showQuickView = false;
                this.showDetailScreen = true;
              }
            } else {
              for (var items of this.detDetails) {
                if (items.maherError != null) {
                    items.status_description = items.maherError;
                } else {
                  if (items.claim_date != null) {
                    items.claim_date = this.getNiceDate(items.claim_date);
                  }
                  if (items.ap_transfered_date != null) {
                    items.ap_transfered_date = this.getNiceDate(items.ap_transfered_date);
                  }
                  if (items.authorized_amount != null && items.authorized_amount != "0") {
                    items.authorized_amount = this.getNiceCurrency(items.authorized_amount);
                  } else if (items.authorized_amount == "0") {
                    items.authorized_amount = "";
                  }
                  if (items.claim_amount != null && items.claim_amount != "0") {
                    items.claim_amount = this.getNiceCurrency(items.claim_amount);
                  } else if (items.claim_amount == "0") {
                    items.claim_amount = "";
                  }
                }
                this.showQuickView = true;
                this.showDetailScreen = false;

                this.search1.reset();
                if (window.innerWidth > 750 && window.innerWidth <1150){
                  this.allowIn = false;
                }
                this.quickViewData = new MatTableDataSource<DetentionClaimsView>(this.detDetails);
                this.quickViewData.sortingDataAccessor = (item, property) => {
                  switch (property) {
                    case 'claim_date':
                      return new Date(item.claim_date);
                    case 'ap_transfered_date':
                      return new Date(item.ap_transfered_date);
                    case 'payment_date':
                      return new Date(item.payment_date);
                    default:
                      return item[property];
                  }
                };
              }
          }
        }else{
          this.badSearch = true;
        }

      });

    //  }
  }

  nextTransaction() {
      this.currentIndx++;
      if (this.currentIndx<this.detDetails.length){
        for (var dd=this.currentIndx; dd<this.detDetails.length; dd++){
          if (this.detDetails[dd].maherError!=null ) {
            this.currentIndx++;
          }else{
            break;
          }
        }
        this.detDetail = null;
        this.detDetail = {} as DetentionClaimsView;
        this.detDetail = this.detDetails[this.currentIndx];
        this.showAcc = false;
        this.formatDetailScreen();
      }else{
        this.currentIndx=this.detDetails.length-1;
        var _i = this.detDetails.length;
        while (_i--) {
          if (this.detDetails[_i].maherError!=null ) {
          } else {
            this.currentIndx = _i;
            break;
          }
        }
      }
    }

  previousTransaction() {
      this.currentIndx--;
      if (this.currentIndx>=0){
        for (var dd=this.currentIndx; dd<this.detDetails.length; dd--){
          if (this.detDetails[dd].maherError!=null ) {
            this.currentIndx--;
          }else{
            break;
          }
        }
        this.detDetail = null;
        this.detDetail = {} as DetentionClaimsView;
        this.detDetail = this.detDetails[this.currentIndx];
        this.showAcc = false;
        this.formatDetailScreen();
      }else{
        this.currentIndx=0;
      }

    }

  returnToSearch() {
    this.showQuickView = false;
    this.showDetailScreen = false;
  }
  returnToQuickView() {
    this.showQuickView = true;
    this.showDetailScreen = false;
  }


  showDetails(rowIn: DetentionClaimsView) {
    if (rowIn.maherError!=null){
        return;
    }

    this.currentIndx = this.detDetails.findIndex(xx => xx.detention_claim_id == rowIn.detention_claim_id);
    this.showQuickView = false;
    this.showDetailScreen = true;
    this.showAcc = false;
    this.detDetail = null;
    this.detDetail = {} as DetentionClaimsView;
    this.detDetail = rowIn;
    this.formatDetailScreen();
  }





  getNiceDate(dateIn: string): string {
    this.date1 = new Date(dateIn);
    return this.date1.toLocaleDateString("en-US", this.options4);
  }


  getNiceDateTimeForDate(dateIn: Date): string {
    return dateIn.toLocaleDateString("en-US", this.options4);
  }


  getNiceWeight(weightIn: string): string {
    this.number1 = Number.parseInt(weightIn);
    return this.number1.toLocaleString("en-US", this.options2);
  }

  getNiceCurrency(numberIn: string): string {
    this.number1 = parseFloat(numberIn);
    return this.number1.toLocaleString("en-US", this.options3);
  }


  formatDetailScreen() {
    if (this.detDetail.detention_claim_id == null) {
      this.detDetail.detention_claim_id = " ";
    }
    if (this.detDetail.claim_amount == null || this.detDetail.claim_amount == "" ) {
      this.detDetail.claim_amountFmt = " ";
    }else{
      this.detDetail.claim_amountFmt = this.detDetail.claim_amount;
    }
    if (this.detDetail.claim_date == null) {
      this.detDetail.claim_date_fmt = " ";
    }
    if (this.detDetail.claim_by_description == null) {
      this.detDetail.claim_by_description = " ";
    }
    if (this.detDetail.visit == null) {
      this.detDetail.visit = " ";
    }
    if (this.detDetail.visit_date == null) {
      this.detDetail.visit_date = " ";
    }
    if (this.detDetail.status_description == null) {
      this.detDetail.status_description = " ";
    }
    if (this.detDetail.payment_amount == null || this.detDetail.payment_amount=="") {
      this.detDetail.payment_amountFmt = " ";
    }else{
      this.detDetail.payment_amountFmt = this.getNiceCurrency(this.detDetail.payment_amount);

    }


    if (this.detDetail.authorized_amount == null || this.detDetail.authorized_amount=="") {
      this.detDetail.authorized_amountFmt = " ";
    }else{
      this.detDetail.authorized_amountFmt = this.detDetail.authorized_amount;

    }
    if (this.detDetail.rejection_description == null) {
      this.detDetail.rejection_description = " ";
    }
    if (this.detDetail.rejected_date == null) {
      this.detDetail.rejected_date = " ";
    }

    if (this.detDetail.authorized_date == null) {
      this.detDetail.authorized_date_fmt = " ";
    }
    if (this.detDetail.payment_number == null) {
      this.detDetail.payment_number = " ";
    }
    if (this.detDetail.data_research_remarks == null) {
      this.detDetail.data_research_remarks = " ";
    }
    if (this.detDetail.claim_remarks == null) {
      this.detDetail.claim_remarks = " ";
    }
    if (this.detDetail.payment_date == null) {
      this.detDetail.payment_date = " ";
    }
  }


  getListData2(){
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];

    this.listData = []
    this.listDataObj = {} as ListData;
    this.listData.push(this.listDataObj);

    this.clientRequest.requestData = this.listData;

    const lhsUserObs$ = this.queryService.getLists(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this.listData = lstConts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
          this.fillUpSavedLists();
      });

  }


  deleteHit(){
    this.myApp.showConfirmBanner("Confirm","confirm delete of list: "+this.savedLists2[this.savedLists2.findIndex(xx=>xx.id==this.savedList2)].description,"detentionClaims");
    return;
  }

  updateContainerList(fromWhere: string){
    this.submitted = true;
    this.insertNoConts = false;
    this.noListName = false;
    this.insertListExists = false;
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.listDataObj = null;
    this.listDataObj =  {} as ListData;
    if (fromWhere=="D"){
      var indx = this.listData.findIndex(xx => xx.id == this.savedList2);
      if (indx!=-1){
        this.listDataObj = this.listData[indx];
      }
      this.listDataObj.data = [];
      this.clientRequest.requestData = [];
      this.clientRequest.requestData[0] = this.listDataObj;
    }else{
      if (this.savedList=="VISIT"){
        this.listDataObj.type = "V";
      }else{
        this.listDataObj.type = "L";
      }

      if (this.txtFromArea==undefined || this.txtFromArea==""){
        if (fromWhere=="I"){
          if (this.savedList=="VISIT"){
            this.stringOut = "Visit";
          }else{
            this.stringOut = "Claim";
          }
          this.insertNoConts = true;
        }
        return;
      }
      if (fromWhere=="I" && (this.myNewListName==null || this.myNewListName=="")){
        this.noListName = true;
        return;
      }

      if (fromWhere=="I" &&  this.listData.findIndex(xx => xx.name == this.myNewListName && xx.type ==this.listDataObj.type) !=-1){
        this.insertListExists = true;
        return;
      }

      this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
      if (this.txtArray2.length==0){
        this.didntEnterShit = true;
        return;
      }
      this.didntEnterShit = false;
      var _i = this.txtArray2.length;
      while (_i--) {
        if (this.txtArray2[_i].valueOf() == "") {
          this.txtArray2.splice(_i, 1);
        }
      }

      if (fromWhere!="D"){
        if (fromWhere=="I"){
          if (this.savedList=="VISIT"){
            this.listDataObj.type = "V";
          }else if (this.savedList=="CLAIMNUMBER"){
            this.listDataObj.type = "L";
          }
          this.listDataObj.name = this.myNewListName;
        }else{
          var indx = this.listData.findIndex(xx => xx.id == this.savedList2);
          if (indx!=-1){
            this.listDataObj = this.listData[indx];
          }
        }
        this.listDataObj.data = this.txtArray2;
        this.clientRequest.requestData = [];
        this.clientRequest.requestData[0] = this.listDataObj;
      }
    }

    this.clientRequest.user = this.myUser;

    const lhsUserObs$ = this.queryService.updateContainerList(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this.listData = lstConts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        var id = this.savedList2;
        this.fillUpSavedLists();
        if (this.savedLists2.length > 0) {
          if (fromWhere == "I") {
            this.savedList2 = this.savedLists2[this.savedLists2.findIndex(xx=> xx.code == this.myNewListName)].id;
          } else if (fromWhere== "D") {
            this.savedList2 = this.savedLists2[0].id;
          }else{
            this.savedList2 = this.savedLists2[this.savedLists2.findIndex(xx=> xx.id == id)].id;
          }
        }
        this.myNewListName = "";

        if (fromWhere=="I"){
          this.myApp.showSuccessBanner("","the new list has been created successfully","detentionClaims");
        }else if (fromWhere=="D"){
          this.myApp.showSuccessBanner("",this.myNewListName + " has been deleted successfully","detentionClaims");
        }else{
          this.myApp.showSuccessBanner("","List has been updated successfully","detentionClaims");

        }

        this.submitted= false;

      });

  }

  showContainersFromList(){
    var indx = this.listData.findIndex(xx => xx.id == this.savedList2);
    if (indx!=-1){
      this.txtFromArea = "";
      for (var ii=0;ii<this.listData[indx].data.length; ii++){
        this.txtFromArea =  this.txtFromArea + this.listData[indx].data[ii].valueOf() + '\r\n';
      }
    }
  }



}
